import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=5bee81a9&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bee81a9')) {
      api.createRecord('5bee81a9', component.options)
    } else {
      api.reload('5bee81a9', component.options)
    }
    module.hot.accept("./Bookmarks.vue?vue&type=template&id=5bee81a9&", function () {
      api.rerender('5bee81a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/Bookmarks.vue"
export default component.exports